import partners from '../../partners';
import { routes } from '../constants';

const DEFAULT_TRAFFIC_SOURCE_CODE = 'DRT';
const TRAFFIC_SOURCE_CODE_START = 12;
const TRAFFIC_SOURCE_CODE_LENGTH = 3;
const S_PARAM_LENGTH = 20;
const PLACEHOLDER_CHAR = 'x';

const PAID_CLICK_PARAMS = ['gclid', 'gbraid', 'wbraid', 'gad_source', 'gad_campaignid', 'msclkid'];

// Referrer host -> traffic-source code, per Ivan's SEO_GEO Tracking Reference Table.
// Subdomains resolve to their parent entry (see hostCandidates), so only list a subdomain when it needs a
// DIFFERENT code from its parent — e.g. gemini.google.com -> GMN, not GNS.
const REFERRER_TRAFFIC_SOURCE_CODES = new Map([
    ['yahoo.com', 'YOG'],
    ['bing.com', 'OGB'],
    ['google.com', 'GNS'],
    ['duckduckgo.com', 'DCK'],
    ['ecosia.org', 'ECO'],
    ['msn.com', 'MSO'],
    ['onet.pl', 'ONT'],
    ['seznam.cz', 'SEZ'],
    ['chatgpt.com', 'GPT'],
    ['chat.openai.com', 'GPT'],
    ['gemini.google.com', 'GMN'],
    ['copilot.microsoft.com', 'CPT'],
    ['copilot.com', 'CPT'],
    ['perplexity.ai', 'PRP'],
    ['claude.ai', 'CLD'],
    ['grok.com', 'GRK'],
    ['x.com', 'GRK']
]);

const UTM_SOURCE_TRAFFIC_SOURCE_CODES = new Map([
    ['yahoo', 'YOG'],
    ['bing', 'OGB'],
    ['google', 'GNS'],
    ['duckduckgo', 'DCK'],
    ['ecosia', 'ECO'],
    ['msn', 'MSO'],
    ['onet', 'ONT'],
    ['seznam', 'SEZ'],
    ['chatgpt', 'GPT'],
    ['openai', 'GPT'],
    ['gemini', 'GMN'],
    ['copilot', 'CPT'],
    ['perplexity', 'PRP'],
    ['claude', 'CLD'],
    ['grok', 'GRK']
]);

// Most specific host first, so gemini.google.com wins over google.com.
const hostCandidates = (hostname: any) => {
    const segments = hostname
        .toLowerCase()
        .replace(/^www\./, '')
        .split('.');
    return segments.slice(0, -1).map((_: any, index: any) => segments.slice(index).join('.'));
};

const getReferrerCandidates = () => {
    try {
        return hostCandidates(new URL(document.referrer).hostname);
    } catch {
        return undefined;
    }
};

const isOrganicLanding = (query: any, brand: any) =>
    brand === partners.DEFAULT &&
    // In-app navigation drops the query string, so only a real landing can be judged organic.
    window.location.pathname === routes.base &&
    !query.get('s') &&
    !query.get('o') &&
    !PAID_CLICK_PARAMS.some((param) => query.has(param));

const resolveTrafficSourceCode = (query: any) => {
    const utmCode = UTM_SOURCE_TRAFFIC_SOURCE_CODES.get((query.get('utm_source') || '').toLowerCase());
    if (utmCode) {
        return utmCode;
    }

    const candidates = getReferrerCandidates();
    if (!candidates) {
        return DEFAULT_TRAFFIC_SOURCE_CODE;
    }

    return (
        candidates.map((candidate: any) => REFERRER_TRAFFIC_SOURCE_CODES.get(candidate)).find(Boolean) ||
        DEFAULT_TRAFFIC_SOURCE_CODE
    );
};

export const getTrafficSourceSParameter = (brand: any) => {
    const query = new URLSearchParams(window.location.search);
    if (!isOrganicLanding(query, brand)) {
        return undefined;
    }

    const trafficSourceCode = resolveTrafficSourceCode(query);
    const base = PLACEHOLDER_CHAR.repeat(S_PARAM_LENGTH);
    return (
        base.slice(0, TRAFFIC_SOURCE_CODE_START) +
        trafficSourceCode +
        base.slice(TRAFFIC_SOURCE_CODE_START + TRAFFIC_SOURCE_CODE_LENGTH)
    );
};
